import auroraColorPalette from '../colors';

const paper = {
  root: {
    backgroundColor: auroraColorPalette.primary.white,
  },
  rounded: {
    borderRadius: 8,
  },
  elevation1: {
    background: 'none',
    boxShadow: 'none !important',
    // '0px 1px 3px 0px rgba(142, 142, 142, 0.2), 0px 1px 1px 0px rgba(243, 243, 243, 0.14), 0px 2px 1px -1px rgba(204, 204, 204, 0.12)',
  },
  elevation2: {
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
  },
  elevation3: {
    boxShadow: '1px 2px 12px rgba(0, 0, 0, 0.1)',
  },
  elevation4: {
    boxShadow:
      '0px 2px 4px -1px rgba(142, 142, 142, 0.2), 0px 4px 5px 0px rgba(243, 243, 243, 0.14), 0px 1px 10px 0px rgba(204, 204, 204, 0.12)',
  },
};

export default paper;
